module.exports = __webpack_public_path__ + "img/tg_02 (2).a1c4fc34.jpg";